(function () {
    var $form = $('.user form:not(.bypass-user-form-validation)');

    if ($form.length === 0) return;

    // Form validation
    var options = {
        groupClass: 'has-error',
        groupSelector: '.form-group',
        errorPosClasses: ['.input-group', '.selectize-control'],
        helpSpanDisplay: 'form-text text-danger',
        delay: false,
        disableSubmitBtn: false,
    };

    var metrics = [
        ['select[name="title"]', 'presence', gmtrans('user.profile.frontend_validation.title_required')],
        ['input[name="first_name"]', 'presence', gmtrans('user.profile.frontend_validation.firstname_required')],
        ['input[name="last_name"]', 'presence', gmtrans('user.profile.frontend_validation.lastname_required')],
        ['input[name="email"]', 'presence', gmtrans('user.profile.frontend_validation.email_required')],
        ['input[name="phone"]', 'presence', gmtrans('user.profile.frontend_validation.phone_required')],
        ['input[name="address1"]', 'presence', gmtrans('user.profile.frontend_validation.address_required')],
        ['input[name="city"]', 'presence', gmtrans('user.profile.frontend_validation.city_required')],
        ['input[name="postcode"]', 'presence', gmtrans('user.profile.frontend_validation.postcode_required')],
        ['input[name="country"]', 'presence', gmtrans('user.profile.frontend_validation.country_required')],
    ];

    $form.nod(metrics, options);
})();